import { useSelector, useDispatch } from "react-redux";
import { Tabs } from "antd";

import "../../styles/components/selectComponent/tabSelection.scss";

const TabSelection = ({
  menuItems,
  currentTabKey,
  setTabAction,
  component,
}) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.generalSlice[currentTabKey]);

  const handleTabChange = (key) => {
    dispatch(setTabAction(key));
  };

  return (
    <div className="tab-selection-container">
      <Tabs
        tabBarGutter={0}
        size="large"
        activeKey={currentTab}
        onChange={handleTabChange}
        indicator={{ size: (origin) => origin - 30, align: "center" }}
        items={menuItems.map((item) => ({
          key: item.key,
          label: (
            <div className="tabs-label">
              <span style={{ fontSize: "17px" }}>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ),
        }))}
        className="tab-selection-tabs"
      />
      <div className="tab-selection-content">{component}</div>
    </div>
  );
};

export default TabSelection;
